import { EAsyncEventTypes } from 'affiny-core/modules/asynchronousState/types';
import { promisifyDispatch } from 'affiny-core/modules/helpers';
import { IRootState } from 'affiny-core/modules/state';
import { selectIsLoading } from 'affiny-core/redux/selectors/asyncStateSelectors';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { postPicturesAction } from '../actions';

const mapStateToProps = (state: IRootState) => ({
  isLoadingPost: selectIsLoading(state, EAsyncEventTypes.POST_PICTURE),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  postPictures: promisifyDispatch(dispatch, postPicturesAction),
});

export type IPostPicturesContainerProps = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

export const postPicturesContainerFactory = connect(
  mapStateToProps,
  mapDispatchToProps
);
